<div class="modal-header">
  <span class="material-icons custom-dismiss" (click)="cancel()">
    arrow_back
  </span>
  Filtrar por clientes
</div>

<div>
  <mat-form-field>
    <input placeholder="Buscar por cliente" matInput (keyup)="searchbarInput($event)">
  </mat-form-field>
</div>

<div class="ion-padding custom-internal-content">


  @if (filteredItems.length > 0) {
    <mat-selection-list (selectionChange)="checkboxChange($event)" #facturas>
      @for (item of filteredItems; track trackItems($index, item)) {
        <mat-list-option [selected]="isChecked(item.deudor)" [value]="item.deudor">{{ item.deudor }}</mat-list-option>
      }
    </mat-selection-list>
  }


  <div class="total-register-label">
    @if (!alternar_msg) {
      <mat-label>Hay {{items.length}} registros.</mat-label>
    }
    @if (alternar_msg) {
      <mat-label>Se encontraron {{filteredItems.length}} registros.</mat-label>
    }
  </div>


  @if (filteredItems.length == 0) {
    <sin-registros></sin-registros>
  }



  <div class="btn-container">
    <button mat-stroked-button  class="primary-button"  (click)="confirmChanges()">
      Confirmar
    </button>
  </div>

</div>